<template>
  <div class="news-list">
    <div class="news-body">
      <div class="news-tabs">
        <div v-for="(tab, index) in tabs" :key="index" class="news-tab" :class="{ active: selectedTab === index }"
          @click="selectTab(tab, index)">
          <img :src="selectedTab === index ? tab.iconSelected : tab.icon" alt="tab icon" />
          <span>{{ tab.label }}</span>
        </div>
      </div>
      <div class="news-content">
        <ul>
          <li v-for="(news, index) in paginatedNewsItems" :key="index" class="news-item"
            :class="{ selected: selectedNews === index }" @click="selectNews(news.id)">
            <img :src="getFirstImage(news)" alt="news image" class="news-image" />
            <div class="news-content">
              <span class="news-title">{{ news.title }}</span>
              <p class="news-description">{{ getPlainText(news.content) }}</p>
              <div class="news-meta">
                <span class="news-time">
                  {{ news.newspaper }} | {{ news.time || '' }}
                </span>
                <span class="news-views">浏览：{{ news.pageView || 0 }}次</span>
              </div>
            </div>
          </li>
        </ul>
        <button class="load-more" v-if="showLoadMore" @click="loadMore">
          加载更多
          <img src="@/assets/home/downIc.png" alt="down icon" class="down-icon" />
        </button>
      </div>

    </div>

  </div>
</template>

<script>
import { listByTYpe } from "@/api/news.js";
import { IMG_BASE_URL } from "@/utils/index.js";
export default {
  name: 'NewsList',
  data() {
    return {
      selectedTab: 0,
      selectedNews: null,
      currentPage: 1, // 当前页码
      itemsPerPage: 5, // 每页显示的新闻条数
      tabs: [
        { label: '全部新闻', icon: 'https://hr2.chnsoft.com.cn/img/newsIcon1.png', iconSelected: 'https://hr2.chnsoft.com.cn/img/newsIcon2.png', value: ' ' },
        { label: '华软新闻', icon: 'https://hr2.chnsoft.com.cn/img/newsIcon1.png', iconSelected: 'https://hr2.chnsoft.com.cn/img/newsIcon2.png', value: '1' },
        { label: '行业资讯', icon: 'https://hr2.chnsoft.com.cn/img/newsIcon1.png', iconSelected: 'https://hr2.chnsoft.com.cn/img/newsIcon2.png', value: '2' },
      ],
      tabType: null,
      newsItems: [

        // ...更多新闻数据
      ],
      selectedTabLabel: '', // 新增：存储当前tab的label
    };
  },
  computed: {
    paginatedNewsItems() {
      // 根据当前页码和每页条数计算显示的新闻
      return this.newsItems.slice(0, this.currentPage * this.itemsPerPage);
    },
    showLoadMore() {
      // 判断是否显示加载更多按钮
      return this.newsItems.length > this.currentPage * this.itemsPerPage;
    },
    IMG_BASE_URL() {
      return IMG_BASE_URL;
    }
  },
  methods: {
    selectTab(tab, index) {
      this.selectedTab = index;
      this.tabType = tab.value;
      this.selectedTabLabel = tab.label; // 新增：切换tab时存label
      this.currentPage = 1; // 切换tab时重置页码
      this.getNews();
    },
    selectNews(id) {
      // 跳转时带上tab label参数
      this.$router.push({ path: '/news_detail', query: { source: id, tabLabel: this.selectedTabLabel } });
    },
    loadMore() {
      // 点击加载更多时，增加当前页码
      this.currentPage++;
    },
    getNews() {
      //分页查询新闻列表请求
      this.currentPage = 1; // 重置当前页码
      this.newsItems = []; // 清空当前新闻列表
      listByTYpe({ type: this.tabType }).then((res) => {
        if (res) {
          // 如果type为1，将newspaper字段改为"华软动态"
          // this.newsItems.forEach(item => {
          //   if (item.type == 1) {
          //     item.newspaper = '华软动态';
          //   }
          // })

          this.newsItems = res.result;
        }
      })
    },
    getFirstImage(news) {
      // 首先检查news.img字段是否有图片
      if (news.img && news.img.trim() !== '') {
        return news.img.split(',')[0];
      }
      
      // 如果没有，再从富文本中提取第一个图片
      const content = news.content;
      if (!content) return '';
      
      // 匹配<img>标签中的src属性
      const imgTagMatch = content.match(/<img\s+src="([^"]+)"/i);
      if (imgTagMatch && imgTagMatch[1]) {
        return imgTagMatch[1];
      }
      
      // 匹配Markdown格式的图片
      const markdownMatch = content.match(/!\[(.*?)\]\((data:image\/[^;]+;base64,[^)]+)\)/i);
      if (markdownMatch && markdownMatch[2]) {
        return markdownMatch[2];
      }
      
      return '';
    },
    getPlainText(content) {
      if (!content) return '';
      
      let plainText = content;
      
      // 移除HTML标签
      plainText = plainText.replace(/<[^>]+>/g, '');
      
      // 移除Markdown格式的图片
      plainText = plainText.replace(/!\[(.*?)\]\(([^)]+)\)/g, '');
      
      // 移除Markdown格式的其他标记
      plainText = plainText.replace(/[*_~`]/g, '');
      
      // 移除多余的空白字符
      plainText = plainText.trim();
      
      return plainText;
    },
  },
  mounted() {
    this.selectedTabLabel = this.tabs[0].label; // 新增：初始化label
    this.getNews(); // 页面加载时调用接口
  },

};
</script>

<style lang="scss" scoped>
.news-list {

  background: #FBFBFB;

  padding-top: 80PX;
  padding-bottom: 80PX;

}

.news-body {
  width: 1200px;
  margin: 0 auto;
  display: flex;
}

.news-tabs {
  display: flex;
  flex-direction: column;
  margin-right: 20PX;
  width: 180px; /* 固定宽度 */
  flex-shrink: 0; /* 防止收缩 */
}

.news-tab {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10PX 30PX 10PX 5PX;
  height: 60PX;
  line-height: 60PX;
  border-right: 1PX solid rgba(15, 107, 246, 0.08);
  &:hover {
    font-weight: bold;
  }
}



.news-tab img {
  width: 20PX;
  height: 20PX;
  margin-right: 10PX;
}

.news-tab span {
  font-size: 1rem;
  color: #1e242acc;
}

.news-tab.active span {
  color: #0f6bf6;
}

.news-tab.active {
  border-right: 2PX solid #0f6bf6;
  font-weight: bold;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
}

.news-tab:nth-child(1),
.news-tab:nth-child(2) {
  border-bottom: 1PX solid rgba(15, 107, 246, 0.08);
  ;
  /* background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%); */
}

.news-content {
  flex: 1; /* 自适应剩余宽度 */
  min-width: 0; /* 确保flex子元素可以收缩 */
}

.news-list h2 {
  font-size: 1.5rem;
  margin-bottom: 10PX;
}

.news-list ul {
  list-style: none;
  padding: 0;
}

.news-item {
  display: flex;
  cursor: pointer;
  margin-bottom: 20PX;
  padding: 20PX;
  padding-bottom: 20PX;
  transition: background-color 0.3s, border-radius 0.3s;
}

/* 鼠标悬浮时背景色为白色并设置圆角 */
// .news-item:hover {
//   background-color: #fff;
//   border-radius: 8PX;
//   box-shadow: 0PX 8PX 32PX 16PX rgba(30, 36, 42, 0.02);
// }

// .news-item.selected {
//   background-color: #fff;
//   /* 选中时的背景颜色 */
//   border-radius: 8PX;

//   /* 选中时的圆角效果 */
//   .news-title {
    
//   }
// }

.news-image {
  width: 210PX;
  height: 140PX;
  /* object-fit: cover; */
  margin-right: 15PX;
  border-radius: 8PX;
}

.news-content {
  margin-left: 20PX;
  flex: 1;
  min-width: 0; /* 确保flex子元素可以收缩 */
}
  
.news-title {

  font-family: PingFang SC;
  font-size: 18PX;
  font-weight: bold;
  color: #1E242A;
  /* 新增单行省略样式 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-description {
  font-size: 14PX;
  color: #555;
  margin: 12PX 0;
  font-family: PingFang SC;
  font-size: 14PX;
  font-weight: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #616A73;
  /* height: 120PX; */
  /* overflow-y: auto; */
  /* 新增多行省略样式 */
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 60PX;
  /* 默认隐藏滚动条（透明） */
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;

  /* Chrome, Edge, Safari 默认隐藏滚动条 */
  &::-webkit-scrollbar {
    width: 3PX;
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 4PX;
    min-height: 20PX;
    transition: background 0.2s;
  }

  &::-webkit-scrollbar-corner {
    background: transparent;
  }
}

/* 鼠标悬浮时显示滚动条 */
.news-description:hover {
  scrollbar-color: #b3b3b3 #f5f5f5;
}

.news-description:hover::-webkit-scrollbar {
  background: #f5f5f5;
}

.news-description:hover::-webkit-scrollbar-thumb {
  background: #b3b3b3;
}

.news-description:hover::-webkit-scrollbar-thumb:hover {
  background: #888;
}

.news-description:hover::-webkit-scrollbar-corner {
  background: #f5f5f5;
}

.news-meta {
  color: #999;
  display: flex;
  justify-content: space-between;
  margin-top: 20PX;
}

.news-meta span {
  margin-right: 10PX;

  font-family: PingFang SC;
  font-size: 14PX;
  font-weight: normal;
  line-height: normal;
  text-align: right;
  letter-spacing: normal;
  color: #1E242A;
  opacity: 0.4;
}

.load-more {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20PX auto;
    padding: 7PX 12PX;
    font-size: 14px;
    color: #1E242A;
    background-color: #fff;
    border: 1PX solid #ccc;
    border-radius: 5PX;
    cursor: pointer;
    margin-top: 40PX;
}

.load-more:hover {
  background-color: #f8f9fa;
  /* 鼠标悬停时背景颜色微调 */
}

.down-icon {
  width: 16PX;
  height: 16PX;
  margin-left: 8PX;
  /* 图片与文本之间的间距 */
}
::v-deep .el-tabs__item {
  /* 修改为您想要的文字大小 */
  font-weight: normal !important;
}
</style>